"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-empty-function */
/**
   * class IComponentServer
   *
   * IComponentServer 组件 server 基类
   */
var IComponentServer = /** @class */ (function () {
    function IComponentServer() {
    }
    /**
       * 组件销毁
       */
    IComponentServer.prototype.destroyed = function () { };
    /**
       * 数据监听回调
       *
       * @param {any} oldValue 旧数据
       * @param {any} newValue 新数据
       */
    IComponentServer.prototype.updateStore = function (oldValue, newValue) { };
    return IComponentServer;
}());
exports.default = IComponentServer;
